document.addEventListener('DOMContentLoaded', function() {

  /* ── CART: Add to cart handler ── */
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');
  productForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(this);
      const submitButton = this.querySelector('button[type="submit"]');
      const originalText = submitButton.textContent;
      if (!formData.get('id')) { alert('Please select a product option'); return; }
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: formData.get('id'), quantity: formData.get('quantity') || 1 })
      })
      .then(r => r.ok ? r.json() : r.json().then(e => { throw new Error(e.description || 'Error') }))
      .then(() => {
        submitButton.textContent = 'Added!';
        submitButton.style.background = '#C8813A';
        submitButton.style.color = '#fff';
        setTimeout(() => { window.location.href = '/cart'; }, 800);
      })
      .catch(err => {
        alert('Error adding to cart: ' + err.message);
        submitButton.textContent = originalText;
        submitButton.disabled = false;
      });
    });
  });

  /* ── PAGE TRANSITION: fade out on link click ── */
  document.body.style.opacity = '0';
  document.body.style.transition = 'opacity 0.4s ease';
  setTimeout(() => { document.body.style.opacity = '1'; }, 50);

  document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href');
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('mailto') ||
      href.startsWith('tel') ||
      href.includes('javascript') ||
      link.target === '_blank' ||
      link.closest('.rv-mobile-menu') ||
      link.closest('.rv-hamburger')
    ) return;

    link.addEventListener('click', function(e) {
      const target = this.getAttribute('href');
      if (!target || target.startsWith('#')) return;
      e.preventDefault();
      document.body.style.opacity = '0';
      setTimeout(() => { window.location.href = target; }, 350);
    });
  });

  /* ── SCROLL ANIMATIONS: fade up on scroll ── */
  const animTargets = [
    '.rv-ritual-step',
    '.rv-shop-card',
    '.rv-card',
    '.rv-founder-chapter',
    '.section-header',
    '.rv-founder-intro',
    '.rv-founder-quote',
    '.rv-founder-tagline',
    '.testimonial-content',
    '.rv-brand-panel',
    '.rv-bundle-card',
    '.collection-header',
    '.about-section .section-header',
  ];

  const style = document.createElement('style');
  style.textContent = `
    .rv-anim {
      opacity: 0;
      transform: translateY(28px);
      transition: opacity 0.7s ease, transform 0.7s ease;
    }
    .rv-anim.rv-visible {
      opacity: 1;
      transform: translateY(0);
    }
    .rv-anim-delay-1 { transition-delay: 0.1s; }
    .rv-anim-delay-2 { transition-delay: 0.2s; }
    .rv-anim-delay-3 { transition-delay: 0.3s; }
  `;
  document.head.appendChild(style);

  animTargets.forEach(selector => {
    document.querySelectorAll(selector).forEach((el, i) => {
      el.classList.add('rv-anim');
      if (i === 1) el.classList.add('rv-anim-delay-1');
      if (i === 2) el.classList.add('rv-anim-delay-2');
      if (i === 3) el.classList.add('rv-anim-delay-3');
    });
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('rv-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.rv-anim').forEach(el => observer.observe(el));

  /* ── BUTTON PULSE: subtle pulse on primary CTA hover ── */
  document.querySelectorAll('.rv-btn-primary, .rv-shop-card-btn, .cart-checkout-button').forEach(btn => {
    btn.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
      this.style.transition = 'transform 0.2s ease, background 0.3s ease';
    });
    btn.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
    });
  });

  /* ── SCROLL HEADER: already handled by scrolled class ── */
  const rvHeader = document.getElementById('rv-header');
  if (rvHeader) {
    window.addEventListener('scroll', () => {
      rvHeader.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

});